module.exports = __webpack_public_path__ + "static/CookieRun-Bold.subset-3dc14b3ac539570029a988168c4b4a28.woff";